


















































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import {
	ConsentCondition,
	ConsentWithId,
	Product,
	WaterExport,
	WaterExportStatusEnum,
} from '@/api';
import { ConsentCouncil, OrgsModule, WaterExportModule } from '@/modules';
import Toast from '@/components/display/toast.vue';
import { ApiUtils } from '@/common/ApiUtils';

@Component({})
export default class WaterConsentExportEditModal extends Vue {
	private readonly toast: Toast = new Toast();
	private readonly waterExportModule: WaterExportModule = new WaterExportModule();
	private readonly orgsModule: OrgsModule = new OrgsModule();

	@Prop({ required: true })
	public modalId!: string;

	@Prop({ required: true })
	public product!: Product;

	@Prop({ required: true })
	public consent!: ConsentWithId & ConsentCouncil & { active?: boolean; consentconditions?: any[] };

	@Prop({ required: true })
	public waterExport!: WaterExport;

	protected isLoading: boolean = false;
	protected isEditing: boolean = false;
	protected isSaving: boolean = false;

	protected exportStatus: WaterExportStatusEnum | null = null;
	protected exportStatusOptions: { text: string; value: any; disabled?: boolean }[] = [
		{ text: 'Select an export status...', value: null, disabled: true },
		{ text: 'Internal Only', value: WaterExportStatusEnum.InternalOnly },
		{ text: 'Enabled', value: WaterExportStatusEnum.Enabled },
		{ text: 'Disabled', value: WaterExportStatusEnum.Disabled },
	];

	protected exportTo: number | null = null;
	protected exportToOptions: { text?: string; value: any; disabled?: boolean }[] = [];

	protected exportCouncilIdentifier: string = '';

	protected waterMeterIds: number[] = [];
	protected waterMeterOptions: { text: string; value: any }[] = [];

	public async mounted() {
		await this.watchWaterExport();
	}

	@Watch('waterExport')
	public async watchWaterExport() {
		this.isLoading = true;

		this.exportToOptions = [{ text: 'Select an export target', value: null, disabled: true }];
		const exportToOptions =
			(await this.orgsModule.getFtpTargets())?.map(t => ({ text: t.name, value: t.id })) ?? [];
		if (exportToOptions) this.exportToOptions.push(...(exportToOptions ?? []));

		this.waterMeterOptions =
			this.product?.watermeters
				?.map(waterMeter => ({
					text: waterMeter.name,
					value: waterMeter.id,
				}))
				?.sort((a, b) => (a.value ?? 0) - (b.value ?? 0)) ?? [];

		this.isEditing = this.waterExport.id != null;
		this.exportStatus = this.waterExport?.status ?? null;
		this.exportTo = this.waterExport?.targetOrgId ?? null;
		this.exportCouncilIdentifier = this.waterExport?.consentIdentifier ?? '';
		this.waterMeterIds = this.waterExport?.waterMeterIds ?? [];

		this.isLoading = false;
	}

	@Emit('saved')
	public onSaved(consentCondition: ConsentCondition): ConsentCondition {
		return consentCondition;
	}

	protected notValid(): boolean {
		return (
			this.exportStatus == null ||
			this.exportTo == null ||
			this.exportCouncilIdentifier.length === 0 ||
			this.waterMeterIds.length === 0
		);
	}

	protected async submit(event: Event): Promise<void> {
		event.preventDefault();

		if (!this.product?.id) return;

		this.isSaving = true;
		const data: WaterExport = {
			productId: this.product.id,
			targetOrgId: this.exportTo ?? undefined,
			status: this.exportStatus ?? undefined,
			waterMeterIds: this.waterMeterIds ?? [],
			consentIdentifier: this.exportCouncilIdentifier,
		};
		try {
			const saved = (await this.waterExportModule.save(data, this.waterExport?.id ?? undefined))
				.data;
			this.$bvModal.hide(this.modalId);
			if (saved) this.onSaved(saved);
		} catch (e) {
			const { errorMessage } = ApiUtils.handleApiError(
				e,
				'There was an issue saving the water export',
			);
			this.toast.makeToast(errorMessage, 'Error', 'danger');
		}
		this.isSaving = false;
	}
}
